import React from "react";
import t from "Utils/translation";
import Button from "Components/button/Button";
import RadioButton from "Components/radiobutton/RadioButton";
import { allCountries } from "@/config";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";

const CustomerTypeSelection = ({
  formData,
  setFormFieldValue,
  onFormCancel,
  nextStep,
  stepper,
  formErrors,
  setFormErrors,
}) => {
  const changeCountry = (val) => {
    if (val.country !== "IT") {
      setFormFieldValue({ customer_type: "company" });
    }

    setFormFieldValue(val);
  };

  const validateAndNext = () => {
    let errors = {};
    let requireds = ["country", "customer_type"];

    requireds.forEach((field) => {
      if (!formData[field]) errors[field] = t("input.error.empity");
    });

    if (Object.keys(errors).length === 0) {
      nextStep();
    } else {
      setFormErrors(errors);
    }
  };

  return (
    <div className="flex flex-col items-center h-full p-4 pb-0">
      {stepper}

      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.add.stepCustomerType.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.add.stepCustomerType.desc")}</div>
        <Button docsKey="" className="btnDocsFP" color="docs">
          button.docs
        </Button>
      </div>

      <div className="formContainer">
        <div className="flex flex-col w-full">
          <div className="mt-9">
            <div className="inputFull2">
              <div className="settingTitle">{t("order.add.desc.step1")}</div>
            </div>

            <div className="mt-2 mb-20">
              <Select
                className="inputFull2"
                label={t("input.label.select.country")}
                components={{ DropdownIndicator }}
                name="country"
                options={allCountries}
                errors={formErrors.country}
                onChange={changeCountry}
                clearable={false}
                value={formData.country}
                required
              />
            </div>

            <div className="inputFull2">
              <div className="settingTitle">{t("delivery.accounts.add.stepCustomerType.typeSelection.title")}</div>
            </div>
            <div className="mt-2">
              <RadioButton
                className="inputFull2"
                //eslint-disable-next-line react/no-children-prop
                children={[
                  {
                    value: "private",
                    label: t("delivery.accounts.add.stepCustomerType.typeSelection.private.label"),
                    disabled: formData.country !== "IT",
                  },
                  { value: "company", label: t("delivery.accounts.add.stepCustomerType.typeSelection.company.label") },
                  {
                    value: "reseller",
                    label: t("delivery.accounts.add.stepCustomerType.typeSelection.reseller.label"),
                  },
                ]}
                name="customer_type"
                value={formData.customer_type}
                onChange={setFormFieldValue}
                errors={formErrors.customer_type}
              />
            </div>
          </div>
        </div>
        <div className="formFooter">
          <Button color="text" type="button" onClick={onFormCancel}>
            button.cancel
          </Button>
          <Button color="accent" onClick={validateAndNext}>
            button.continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomerTypeSelection;
